<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-users"></i></div>
      <div>
        Utilisateurs
        <div class="page-title-subheading">Comptes d'accès à la plateforme</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-2">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvel utilisateur
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light mb-1 me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light mb-1 me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3 mb-1">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                Désactiver</button>
                                <button *ngIf="selected_data && buttonsPermission.edit" (click)="show(resetContent)" type="button"  class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3 mb-1">
                                    Reinitialiser le mot de passe du compte</button>
                    </div>

                  
                
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Identité</th>
                                    <th>email</th>
                                    <th>Catégorie d'utilisateur</th>
                                    <th>Rôle</th>
                                    <th>Espace de travail</th>
                                    <!-- <th>Accès tableau de bord</th> -->
                                    <th>status</th>
                        
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'users' | paginate: {
                                    id:'ngxP1',
                                    itemsPerPage: pg.pageSize,
                                    currentPage: pg.p,
                                    totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.name}}</td>
                                    <td>{{d.email}}</td>
                                    <td>
                                        <span *ngIf="d.professor!=null">ENSEIGNANT</span> <br>
                                        <span *ngIf="d.parent !=null">PARENT D'ELEVE</span>
                                        <span *ngIf="d.student !=null">ELEVE</span>
                                        <span *ngIf="d.professor==null && d.student ==null && d.parent ==null">ADMINISTRATIF </span>
                                        
                                    </td>
                                    <td>
                                        <ul>
                                            <li *ngFor="let r of d.roles">{{r.name}}</li>
                                        </ul>
                                    </td>
                                    <td>{{d.space}}</td>
                                    <!-- <td>
                                        <span *ngFor="let dt of d.dash_tag">{{dt}} |</span>
                                    </td> -->

                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                        </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                        <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>

<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un  compte utilisateur</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="email" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Rôle <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="roles" ngModel [multiple]="true">
                    <ng-option *ngFor="let s of roles" [value]="s.name">{{s.name}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Espace <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="space" ngModel [multiple]="false">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let s of spaces" [value]="s">{{s}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Cycles</label>
                <ng-select [multiple]="true" [(ngModel)]="selectedCycles" name="selectedCycles">
                    <ng-option *ngFor="let c of cycles" [value]="c.id">{{c.name}}</ng-option>
                 </ng-select>
                 <span class="text-helper  text-danger">Nécessaire pour les comptes de responsable pédagogique</span>
             </div>

             <div class=" form-group col-12 mb-3">
                <label for="">Accès tableau de bord <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="dash_tag" ngModel [multiple]="true">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let dt of dashTags" [value]="dt.key">{{dt.label}}</ng-option>
                </ng-select>
            </div>

             <div class="container">
                <div class="form-check">
                    <label class="form-check-label me-5" for="flexCheckChecked">
                      Est signataire ?
                    </label>
                    <input class="form-check-input" type="checkbox" name="is_signer" ngModel id="flexCheckChecked">

                  </div>
             </div>
            
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Créer le compte <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier un utilisateur</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="email" class="form-control" [(ngModel)]="selected_data.email">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">rôle <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="roles" [multiple]="true" [(ngModel)]="selectedRoles">
                    <ng-option *ngFor="let s of roles" [value]="s.name">{{s.name}}</ng-option>
                </ng-select>  
             </div>

             <div class=" form-group col-12 mb-3">
                <label for="">Espace <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="space" [(ngModel)]="selected_data.space" [multiple]="false">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let s of spaces" [value]="s">{{s}}</ng-option>
                </ng-select>
            </div>

             

             <div class=" form-group col-12 mb-3" >
                <label for="">Cycles</label>
                <ng-select [multiple]="true" [(ngModel)]="selectedCycles" name="selectedCycles">
                    <ng-option *ngFor="let c of cycles" [value]="c.id">{{c.name}}</ng-option>
                 </ng-select>
                 <span class="text-helper  text-danger">Nécessaire pour les comptes de responsable pédagogique</span>

             </div>

             <div class=" form-group col-12 mb-3">
                <label for="">Accès tableau de bord <span class="text-danger ml-2">(*)</span></label>
                <ng-select name="dash_tag" [(ngModel)]="selected_data.dash_tag" [multiple]="true">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let dt of dashTags" [value]="dt.key">{{dt.label}}</ng-option>
                </ng-select>
            </div>

             <div class="container">
                <div class="form-check">
                    <label class="form-check-label me-5" for="flexCheckChecked">
                      Est signataire ?
                    </label>
                    <input class="form-check-input" type="checkbox" name="is_signer" [(ngModel)]="selected_data.is_signer" id="flexCheckChecked" >

                  </div>
             </div>
          
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
  <ng-template #resetContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="resetPassword(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Réinitialiser le mot de passe </h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="email" class="form-control" [(ngModel)]="selected_data.email">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Mot de passe <span class="text-danger ml-2">(*)</span></label>
                <input type="password" name="new_password" class="form-control" minlength="8" ngModel>
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Confirmer le mot de passe <span class="text-danger ml-2">(*)</span></label>
                <input type="password" name="confirm_password" class="form-control" minlength="8" ngModel>
            </div> 
           
          
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Réinitialiser <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                  
               
                    <tr >
                        <td class="fw-medium">Email</td>
                        <td >{{selected_data.email}} </td>
                      
                    </tr>
               
                    <tr *ngIf="role=='Admin'" >
                        <td class="fw-medium">Entité</td>
                        <td >{{selected_data.collector?.name}} </td>
                      
                    </tr>
                    <tr *ngIf="role!='Admin'">
                        <td class="fw-medium">Unité administrative</td>
                        <td >{{selected_data.unity_admin?.libelle}} </td>
                      
                    </tr>
               
                    <tr >
                        <td class="fw-medium">rôle</td>
                        <td >{{selected_data.roles[0].name}} </td>
                      
                    </tr>
               
                </tbody>
            </table>
        </div>
      </div>
</ng-template>